import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton/IconButton';
import Tooltip from '@material-ui/core/Tooltip/Tooltip';
import ContentCopy from '@material-ui/icons/FileCopy';
import { connect } from 'react-redux';
import { copyToClipboardV2 } from '../../constants/CommonUtil';
import { infoMessage } from '../../redux/modules/message/message-actions';

class CopiableText extends React.Component {
    onCopy = () => {
        const { dispatch } = this.props;
        const visibleText = this.displayRef && this.displayRef.textContent ?
            this.displayRef.textContent.trim() :
            this.getDisplayText().trim();
        copyToClipboardV2(visibleText);
        dispatch(infoMessage('Copied To Clipboard'));
    };

    getDisplayText = () => {
        const { textToCopy } = this.props;
        if (textToCopy === null || textToCopy === undefined) {
            return '';
        }
        if (typeof textToCopy === 'string') {
            return textToCopy;
        }
        return String(textToCopy);
    };

    displayRef = null;

    render() {
        const { setHtmlDangerously } = this.props;
        const displayText = this.getDisplayText();
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    {
                        setHtmlDangerously ?
                            <div
                                ref={(ref) => {
                                    this.displayRef = ref;
                                }}
                                dangerouslySetInnerHTML={{ __html: displayText }}
                            /> :
                            <span
                                ref={(ref) => {
                                    this.displayRef = ref;
                                }}
                            >
                                {displayText}
                            </span>
                    }
                </div>
                {
                    displayText &&
                    <Tooltip title="Click Here To Copy">
                        <IconButton onClick={this.onCopy} className="ml-1">
                            <ContentCopy />
                        </IconButton>
                    </Tooltip>
                }
            </div>
        );
    }
}

CopiableText.propTypes = {
    textToCopy: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setHtmlDangerously: PropTypes.bool,
    dispatch: PropTypes.func,
};

CopiableText.defaultProps = {
    textToCopy: '',
    setHtmlDangerously: false,
    dispatch: () => {},
};

export default connect()(CopiableText);
